<template>
    <div>
        <v-card>
            <v-toolbar
                flat
                color="primary"
                dark
                dense
            >
                <v-icon left>mdi-briefcase</v-icon>
                  Case Types
                <v-spacer />
                <v-btn
                    round
                    color="success"
                    :to="{name: 'OrgSelectedCaseType', params: {id: 'new'}}"
                >
                    <v-icon left>add</v-icon>
                    New Case Type
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout
                    row
                    wrap
                >
                    <v-flex
                        sm3
                        style="display: flex;flex-direction: column;"
                    >
                        <v-text-field
                          v-model="search"
                          box
                          hide-details
                          :loading="loading"
                          label="Search Types"
                          clearable
                          style="flex-grow: 0;"
                        />
                        <v-list
                            three-line
                            style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                        >
                            <v-list-tile
                                v-for="casetype in ct"
                                :key="casetype.id"
                                :to="{name: 'OrgSelectedCaseType', params: {id: casetype.id}}"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="casetype.name" />
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="!canPrev"
                                icon
                                @click="goPage(-1)"
                            >
                                <
                            </v-btn>
                            &nbsp;
                            {{page * 10 - 9}}
                            -
                            {{page * 10 > total ? total : page * 10}}
                             of 
                            {{total}}
                            &nbsp;
                            <v-btn
                                :disabled="!canNext"
                                icon
                                @click="goPage(1)"
                            >
                                >
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-flex>
                    <v-flex
                        sm9
                    >
                        <v-card
                            v-if="focusCt || loadingCase"  
                            style="margin: 0 10px 0 10px;"
                        >
                            <v-toolbar
                                dense
                                flat
                            >
                                <v-spacer />
                                <v-btn
                                    small
                                    @click="$router.replace({name: 'OrgCaseType'})"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    :disabled="!changed || saving || !canSave"
                                    color="primary"
                                    small
                                    :loading="saving"
                                    @click="saveCaseType()"
                                >
                                    Save Changes
                                </v-btn>
                            </v-toolbar>
  
                            <v-card-text
                                v-if="loadingCase"
                            >
                                <div
                                    style="padding: 25px;margin:auto;text-align: center;"
                                >
                                    <v-progress-circular
                                        indeterminate
                                        query
                                        color="primary"
                                    />
                                </div>
                            </v-card-text>
                            <v-card-text
                                v-if="!loadingCase && focusCt !== null"
                            >
                                <v-text-field
                                  v-model="focusCt.name"
                                  label="Name"
                                  :disabled="saving"
                                  @input="changed = true"
                                />
                                <v-text-field
                                  v-model="focusCt.description"
                                  label="Description"
                                  :disabled="saving"
                                  @input="changed=true"
                                />

                                <div
                                    style="display: flex;align-items: center;"
                                >
                                    <img
                                        v-if="focusCt.icon"
                                        :key="focusCt.icon"
                                        :src="getIconPath(focusCt.id)"
                                        style="max-width:50px;max-height:50px;margin:10px;"
                                    />
                                    <v-flex  d-inline-flex pa-1 style="text-align:center">
                                        <label for="image-upload" class="custom-image-upload">
                                            Case Type Image Upload
                                        </label>
                                        <input id="image-upload" type="file" ref="caseTypeFile" style="display: none;" v-on:change="handleFileUploads()" />
                                    </v-flex>
                                    <v-flex d-inline-flex>
                                        <div v-if="isValidImage" class="filevalidity">
                                            <v-icon style="color:green">
                                                mdi-check
                                            </v-icon>
                                            <span> File has been uploaded</span>
                                        </div>
                                        <div v-else-if="!isValidImage && isValidImage !== null" class="filevalidity">
                                            <v-icon style="color:red">
                                                mdi-exclamation
                                            </v-icon>
                                            <span> File is not compatible, please upload a PNG, JPEG, or GIF</span>
                                        </div>
                                        <div v-else-if="focusCt.icon" class="filevalidity">
                                            <v-icon style="color:green">
                                                mdi-check
                                            </v-icon>
                                            <span>File previously uploaded</span>
                                        </div>
                                    </v-flex>
                                    <br />
                                    <v-flex sm2 style="text-align:center">
                                        <small>
                                            Recommended Size: 480px x 480px
                                        </small>
                                    </v-flex>
                                </div>
                                <v-switch
                                  v-model="focusCt.enabled"
                                  label="Enabled"
                                  persistent-hint
                                  :disabled="saving"
                                  hint="Disabling a case type will close all existing cases, which will hide the case and any forms within the cases from search results & contacts."
                                />
                                <v-tabs
                                    v-model="tabIndex"
                                    style="padding-top: 20px;"
                                >
                                    <v-tab href="#checklist">
                                        Checklist
                                    </v-tab>

                                    <v-tab href="#faq">
                                        FAQ
                                    </v-tab>

                                    <v-tab href="#info">
                                        Info
                                    </v-tab>

                                    <v-tab-item
                                        value="checklist"
                                    >
                                        <div
                                            style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;margin-left: 10px;margin-right: 10px;margin-top: 10px;"
                                        >
                                            <div>
                                                <v-icon
                                                    style="color: #FF9800;"
                                                >
                                                    mdi-help-circle
                                                </v-icon>
                                                Optional Checklist Item
                                            </div>
                                            <div>
                                                <v-icon
                                                    style="color: #4CAF50;"
                                                >
                                                    mdi-check-circle
                                                </v-icon>
                                                Checked by Default
                                            </div>
                                        </div>
                                        <v-card flat>
                                            <v-list
                                                two-line
                                                class="checklist"
                                            >
                                                <v-list-tile
                                                    v-for="(item, index) in focusCt.checklist_items"
                                                    :key="item.id"
                                                    :class="{'selected': editChecklistItem != null && editChecklistItem.id === item.id}"
                                                >
                                                    <v-list-tile-content
                                                        v-if="editChecklistItem == null || editChecklistItem.id !== item.id"
                                                    >
                                                        <v-list-tile-title>
                                                            <v-icon
                                                                v-if="item.delete"
                                                                style="color: #F44336;"
                                                            >
                                                                mdi-delete-circle
                                                            </v-icon>
                                                            <v-icon
                                                                v-if="item.optional"
                                                                style="color: #FF9800;"
                                                            >
                                                                mdi-help-circle
                                                            </v-icon>
                                                            <v-icon
                                                                v-if="item.default"
                                                                style="color: #4CAF50;"
                                                            >
                                                                mdi-check-circle
                                                            </v-icon>
                                                            {{ item.title }}
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title v-html="item.subtitle" />
                                                    </v-list-tile-content>
                                                    <v-list-tile-content
                                                        v-else
                                                    >
                                                        <v-text-field
                                                            v-model="editChecklistItem.title"
                                                            label="Title"
                                                            hint="The title of the checklist item"
                                                            required
                                                            :disabled="saving"
                                                        />
                                                        <v-text-field
                                                            v-model="editChecklistItem.subtitle"
                                                            label="Subtitle"
                                                            hint="An optional subtitle for the checklist item"
                                                            :disabled="saving"
                                                        />
                                                        <v-text-field
                                                            v-if="false"
                                                            v-model="editChecklistItem.key"
                                                            hint="This key is used to identify the checklist item in spreadsheet bulk operations"
                                                            label="Key"
                                                            required
                                                        />  
                                                        <v-checkbox
                                                            v-model="editChecklistItem.optional"
                                                            label="Optional"
                                                            persistent-hint
                                                            hint="If checked, this item will be optional and require a firm user to add it to a case to be visible to the contact"
                                                            :disabled="saving"
                                                        />  
                                                    </v-list-tile-content>
                                                    <v-list-tile-action
                                                        v-if="editChecklistItem == null || editChecklistItem.id !== item.id"
                                                        style="display: flex;flex-direction: row;justify-content: center;align-items: center;"
                                                    >
                                                        <v-btn
                                                            v-if="index > 0"
                                                            icon
                                                            :disabled="editChecklistItem != null || saving"
                                                            @click="moveUpChecklist(item)"
                                                        >
                                                            <v-icon>mdi-chevron-up</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            v-if="index < focusCt.checklist_items.length - 1"
                                                            icon
                                                            :disabled="editChecklistItem != null || saving"
                                                            @click="moveDownChecklist(item)"
                                                        >
                                                            <v-icon>mdi-chevron-down</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            icon
                                                            :disabled="editChecklistItem != null || saving"
                                                            @click="editChecklistItem = JSON.parse(JSON.stringify(item))"
                                                        >
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </v-list-tile-action>
                                                    <v-list-tile-action
                                                        v-else
                                                    >
                                                        <v-btn
                                                            icon
                                                            :disabled="saving"
                                                            @click="editChecklistItem = null"
                                                        >
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            icon
                                                            :disabled="saving"
                                                            @click="editChecklistItem.delete = true;saveChecklistItem(editChecklistItem);"
                                                        >
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            icon
                                                            @click="saveChecklistItem(editChecklistItem)"
                                                            :disabled="saving"
                                                            color="primary"
                                                        >
                                                            <v-icon>mdi-check</v-icon>
                                                        </v-btn>
                                                    </v-list-tile-action>       
                                                </v-list-tile>
                                            </v-list>
                                            <v-btn
                                                v-if="editChecklistItem == null || editChecklistItem.id !== null"
                                                small
                                                color="primary"
                                                :disabled="saving"
                                                @click="editChecklistItem = {id: null, title: '', subtitle: '', key: '', order: 0, default: false, optional: false}"
                                            >
                                                <v-icon left>mdi-plus</v-icon>
                                                New Checklist Item
                                            </v-btn>
                                            <div
                                                v-else
                                                style="padding: 10px;border: 1px solid rgba(0,0,0,.1);border-radius: 5px;"
                                            >
                                                <v-btn
                                                    icon
                                                    @click="editChecklistItem = null"
                                                    :disabled="saving"
                                                >
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                                <span style="font-weight: 600;">New Checklist Item</span>
                                                <v-text-field
                                                    v-model="editChecklistItem.title"
                                                    label="Title"
                                                    hint="The title of the checklist item"
                                                    :disabled="saving"
                                                    required
                                                />
                                                <v-text-field
                                                    v-model="editChecklistItem.subtitle"
                                                    label="Subtitle"
                                                    :disabled="saving"
                                                    hint="An optional subtitle for the checklist item"
                                                />
                                                <v-text-field
                                                    v-if="false"
                                                    v-model="editChecklistItem.key"
                                                    hint="This key is used to identify the checklist item in spreadsheet bulk operations"
                                                    label="Key"
                                                    :disabled="saving"
                                                    required
                                                />
                                                <v-checkbox
                                                    v-model="editChecklistItem.default"
                                                    label="Completed by Default"
                                                    persistent-hint
                                                    :disabled="saving"
                                                    hint="If checked, when added to a case, this item will be set as completed by default"
                                                />  
                                                <v-checkbox
                                                    v-model="editChecklistItem.optional"
                                                    label="Optional"
                                                    persistent-hint
                                                    :disabled="saving"
                                                    hint="If checked, this item will be optional and require a firm user to add it to a case to be visible to the contact"
                                                />  
                                                <v-btn
                                                    icon
                                                    @click="addChecklistItem()"
                                                    color="primary"
                                                    :disabled="saving"
                                                >
                                                    <v-icon>mdi-check</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-tab-item>        

                                    <v-tab-item
                                        value="faq"
                                    >
                                        <v-card
                                            flat
                                        >
                                            <div>
                                                <v-card
                                                    v-for="(cat, index) in focusCt.faq.slice().sort((a, b) => a.order - b.order)"
                                                    :key="cat.id"
                                                    style="margin: 10px; padding: 10px;"
                                                >
                                                    <v-text-field
                                                        v-model="cat.title"
                                                        label="Category Title"
                                                        :disabled="saving"
                                                    />
                                                    <v-expansion-panel
                                                        v-model="faqExpansionPanelFocus[cat.id]"
                                                        focusable
                                                    >
                                                        <v-expansion-panel-content
                                                            v-for="(item, index) in cat.entries"
                                                            :key="item.id"
                                                        >
                                                            <template v-slot:header>
                                                                {{ item.title }}
                                                            </template>
                                                            <v-card-text
                                                                class="grey lighten-3"
                                                            >
                                                                <v-text-field
                                                                    v-model="item.title"
                                                                    label="FAQ Title"
                                                                    :disabled="saving"
                                                                />
                                                                <v-textarea
                                                                    v-model="item.text"
                                                                    label="FAQ Text"
                                                                    :disabled="saving"
                                                                />
                                                                <v-btn
                                                                    icon
                                                                    :disabled="saving"
                                                                    @click="cat.entries.splice(index, 1); faqExpansionPanelFocus[cat.id] = null"
                                                                >
                                                                    <v-icon color="red">mdi-delete</v-icon>
                                                                </v-btn>
                                                            </v-card-text>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                    <v-toolbar
                                                        flat
                                                        dense
                                                        style="justify-content: space-between;align-items: center;margin-top: 5px;"
                                                    >
                                                        <v-btn
                                                            small
                                                            color="primary"
                                                            :disabled="saving"
                                                            @click="cat.entries.push({id: $uuid.v1(), title: 'New FAQ Entry', text: 'Customize the text of your FAQ entry', order: cat.entries.length, category: cat.id}); faqExpansionPanelFocus[cat.id] = cat.entries.length - 1"
                                                        >
                                                            <v-icon left>mdi-plus</v-icon>
                                                            New FAQ Entry
                                                        </v-btn>
                                                        <v-spacer />
                                                        <v-btn
                                                            :disabled="index === 0"
                                                            @click="moveUpCategory(cat)"
                                                            icon
                                                        >
                                                            <v-icon left>mdi-chevron-up</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            icon
                                                            :disabled="index === focusCt.faq.length - 1"
                                                            @click="moveDownCategory(cat)"
                                                        >
                                                            <v-icon left>mdi-chevron-down</v-icon>
                                                        </v-btn>
                                                        <v-spacer />
                                                        <v-btn
                                                            small
                                                            color="red"
                                                            dark
                                                            :disabled="saving"
                                                            @click="focusCt.faq.splice(index, 1); delete faqExpansionPanelFocus[cat.id]"
                                                        >
                                                            <v-icon left>mdi-delete</v-icon>
                                                            Delete Category
                                                        </v-btn>
                                                    </v-toolbar>
                                                </v-card>
                                                <v-btn
                                                    small
                                                    color="primary"
                                                    :disabled="saving"
                                                    @click="addCategory"
                                                >
                                                    <v-icon left>mdi-plus</v-icon>
                                                    New FAQ Category
                                                </v-btn>
                                            </div>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item
                                        value="info"   
                                    >
                                        <v-card
                                            flat
                                            style="overflow: auto;"
                                        >
                                            <Editor
                                                :enable_html="true"
                                                :html="focusCt.info"
                                                ref="htmlEditor"
                                                @changed="changed = true"
                                            >
                                            </Editor>
                                        </v-card>
                                    </v-tab-item>                       
                                </v-tabs>
                            </v-card-text>
                        </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select a Case Type to edit or create a new Case Type</b>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About Cases &amp; Case Types
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              Cases organize related Forms into one container, allowing for cleaner separation and organization of Forms of different parties or Case Types within a single Contact.<br /><br />
                              Case Types allow you to name these groups of Forms with a common label, and set an icon that is displayed to Contacts.
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
  </template>
    
  
<script>
  import api from '@/api'
  import Editor from '@/components/admin/Editor'
  
  export default {
      components:{ Editor },
      data () {
          return {
            ct: null,
            focusCt: null,
            changed: false,
            loading: false,
            loadingCase: false,
            saving: false,
            search: null,
            page: 1,
            canNext: false,
            canPrev: false,
            total: 0,
            isValidImage: null,
            imageChanged: false,
            editChecklistItem: null,
            tabIndex: 0,
            deletedChecklistItems: [],
            nonCompatibleImageTypes: [
                'tiff',
                'svg+xml'
            ],
            faqExpansionPanelFocus: {},
            faqCategoryEdit: null,
            infoChanged: false,
          }
      },
      created () {
          if (this.$route.params.id) {
            this.loadingCase = true
            this.getCaseType(this.$route.params.id)
          }
          this.getCaseTypes()
          this.documentTitle('Case Types')
      },
      methods: {
        addCategory () {
            var tmpUuid = this.$uuid.v1()
            this.focusCt.faq.push({id: tmpUuid, title: 'New FAQ Category', order: this.focusCt.faq.length, entries: []})
            this.faqExpansionPanelFocus[tmpUuid] = null
        },
        moveUpCategory(item) {
            if (!this.focusCt || !this.focusCt.faq) return
            const items = this.focusCt.faq
            items.sort((a, b) => a.order - b.order)
            const idx = items.findIndex(i => i.id === item.id)
            if (idx > 0) {
                const prevItem = items[idx - 1]
                const currentOrder = item.order
                item.order = prevItem.order
                prevItem.order = currentOrder
                items.sort((a, b) => a.order - b.order)
                this.changed = true
            }
            this.$forceUpdate()
        },
        moveDownCategory(item) {
            if (!this.focusCt || !this.focusCt.faq) return
            const items = this.focusCt.faq
            items.sort((a, b) => a.order - b.order)
            const idx = items.findIndex(i => i.id === item.id)
            if (idx < items.length - 1 && idx !== -1) {
                const nextItem = items[idx + 1]
                const currentOrder = item.order
                item.order = nextItem.order
                nextItem.order = currentOrder
                items.sort((a, b) => a.order - b.order)
                this.changed = true
            }
            this.$forceUpdate()
        },
        addChecklistItem() {
            this.editChecklistItem.order = this.focusCt.checklist_items.length
            this.editChecklistItem.id = this.$uuid.v1()
            this.focusCt.checklist_items.push(this.editChecklistItem)
            this.editChecklistItem = null
        },
        saveChecklistItem(item) {
            if (!item || !this.focusCt || !this.focusCt.checklist_items) return;
            this.focusCt.checklist_items = this.focusCt.checklist_items.map(i => {
                if (i.id === item.id) {
                    return {
                        ...i,
                        title: item.title,
                        subtitle: item.subtitle,
                        key: item.key,
                        default: item.default,
                        optional: item.optional,
                        order: item.order,
                        delete: item.delete || false
                    }
                }
                return i;
            });
            this.editChecklistItem = null;
        },
        moveUpChecklist(item) {
            if (!this.focusCt || !this.focusCt.checklist_items) return;
            const items = this.focusCt.checklist_items;
            const idx = this.focusCt.checklist_items.findIndex(i => i.id === item.id);
            if (idx > 0) {
                [items[idx - 1], items[idx]] = [items[idx], items[idx - 1]];
                items.forEach((it, i) => { it.order = i; });
                this.changed = true;
            }
            this.$forceUpdate()
        },
        moveDownChecklist(item) {
            if (!this.focusCt || !this.focusCt.checklist_items) return;
            const items = this.focusCt.checklist_items;
            const idx = items.findIndex(i => i.id === item.id);
            if (idx < items.length - 1 && idx !== -1) {
                [items[idx], items[idx + 1]] = [items[idx + 1], items[idx]];
                items.forEach((it, i) => { it.order = i; });
                this.changed = true;
            }
            this.$forceUpdate()
        },
        updateChecklistItem(item) {
            this.editChecklistItem = item
        },
        handleFileUploads() {
            this.focusCt.logo = this.$refs.caseTypeFile.files[0]
            this.isValidImage = this.isFileAnImage(this.focusCt.logo)
            if (this.isValidImage) {
                this.imageChanged = true
                this.changed = true
            }
        },
        isFileAnImage(file) {
            return file.type.split('/')[0] === 'image' && !this.nonCompatibleImageTypes.includes(file.type.split('/')[1])
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
        goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getCaseTypes(this.search)
            }
        },
        getCaseTypes (search = null) {
            this.loading = true
            api.cases.casetype.list({
            search: search, 
            pageNum: this.page
            })
                .then((data) => {
                    this.total = data['count']
                    this.canNext = data['next_page'] !== null
                    this.canPrev = data['previous_page'] !== null
                    this.ct = data['results']
                    this.loading = false
                })
        },
        getCaseType (id) {
            this.deletedChecklistItems = []
            this.editChecklistItem = null
            this.saving = false
            this.isValidImage = null
            this.focusCt = null
            this.changed = false
            this.tabIndex = 0
            this.loadingCase = true
                api.cases.casetype.get(id)
                    .then((data) => {
                        this.focusCt = data
                        this.changed = false
                    })
        },
        saveCaseType () { 
            this.saving = true
            delete this.focusCt.icon
            this.focusCt.checklist_items = this.focusCt.checklist_items.filter(i => !i.delete)
            this.focusCt.info = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
            api.cases.casetype.save(this.focusCt)
            .then(casetype => {
                if(this.imageChanged) {
                    const data = new FormData()
                    data.append("icon", this.focusCt.logo)
                    data.append("id", casetype.id)
                    api.cases.casetype.save(data).then(() => {
                        if ('id' in this.focusCt) {
                            this.focusCt = casetype
                        } else {
                            this.ct.push(casetype)
                            this.$router.replace({name: 'OrgSelectedCaseType', params: {id: casetype.id}})
                        }
                        this.changed = false
                        this.saving = false
                    })
                } else {
                    if ('id' in this.focusCt) {
                        this.focusCt = casetype
                    } else {
                        this.ct.push(casetype)
                        this.$router.replace({name: 'OrgSelectedCaseType', params: {id: casetype.id}})
                    }
                    this.saving = false
                    this.changed = false
                }
            })
            .finally(() => {
                this.saving = false
                this.changed = false
                this.getCaseTypes(this.search)
                this.$forceUpdate()
            })
        }
      },
      async beforeRouteUpdate(to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
      beforeRouteLeave (to, from, next) {
          if (this.changed) {
              const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
              if (!answer)
                  return false
          }
          next()
      },
        computed:{
            canSave(){
                return this.isValidName && ((this.isValidImage || this.focusCt.icon) || this.focusCt.icon == null)
            },
            isValidName(){
                return this.focusCt.name !== '' && this.focusCt.name != null
            }
        },
      watch: {   
          $route (to, from) {
              if (to.params.id == "new") {
                this.loadingCase = true
                this.focusCt = {
                  name: 'A New Case Type',
                  description: '',
                  enabled: true,
                  faq: [],
                  checklist_items: []
                }
                this.changed = false
                this.loadingCase = false
              }
              else if (to.params.id) {
                  this.getCaseType(to.params.id)
              } 
              else {
                  this.focusCt = null
              } 
          },
          search () {
              this.page = 1
              this.getCaseTypes(this.search)
          },
          focusCt: {
              handler(newValue, oldValue) {
                  if (this.loadingCase || !this.$route.params.id) {
                      this.changed = false
                      this.loadingCase = false
                  }
                  else if (this.saving){
                    this.changed = false
                  }
                  else if (this.$route.params.id === 'new') {
                    this.changed = true
                  }        
              },
              deep: true,
              flush: 'post'
          }
      }
  }
  </script>
    
<style>
    
.filevalidity {
    text-align: left;
    display: inline-block;
    align-self: flex-end;
}

.custom-image-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 10px 12px;
    cursor: pointer;
    color: white;
    background-color: #2196f3;
    letter-spacing: .1em;
}

.checklist > div:nth-child(even) {
  background-color: rgba(0,0,0,0.05);
}

.checklist .v-list__tile {
  transition: height 0.25s ease-in;
}

.checklist > div.selected > .v-list__tile {
  height: 350px !important;
}

.checklist .v-input {
    margin-top: unset !important;
    width: 100%;
}
</style>
    